<template>
  <div class="calculator-container">
    <!-- 操作栏 -->
    <div class="toolbar">
      <div class="row">
        <el-select 
          v-model="taxMode" 
          placeholder="请选择个税承担方式" 
          @change="onTaxModeChange"
          style="max-width: 200px;"
        >
          <el-option
            label="个税计算方式：个人承担"
            value="personal"
          />
          <el-option
            label="个税计算方式：企业承担"
            value="company"
          />
        </el-select>
        <div class="toolbar-buttons">
          <button class="btn btn-primary" @click="addPerson">添加人员</button>
          <button class="btn btn-primary" @click="autoInput">一键录入</button>
        </div>
      </div>
      <!-- <div class="row" style="margin-top: 12px;">
        <el-select 
          v-model="taxMode" 
          placeholder="请选择个税承担方式" 
          @change="onTaxModeChange"
          style="width: 100%;"
        >
          <el-option
            label="个税计算方式：个人承担"
            value="personal"
          />
          <el-option
            label="个税计算方式：企业承担"
            value="company"
          />
        </el-select>
      </div> -->
     
    </div>
    <!-- 多平台表格区域 -->
    <div v-for="(platform, platformIndex) in platforms" :key="platform.id" class="platform-section">
      <div class="platform-header">
        <h3 class="platform-title">{{ platform.name }}</h3>
        <button 
          v-if="platforms.length > 1" 
          class="btn btn-danger btn-small" 
          
          @click="deletePlatform(platformIndex)"
          title="删除平台"
        >
          删除平台
        </button>
      </div>
      
      <!-- 表格区域 -->
      <div class="table-container">
        <div class="table-wrapper">
          <table class="salary-table">
            <thead>
              <tr>
                <th class="month-header">月份</th>
                <th v-for="(person, index) in platform.persons" :key="person.id" class="person-header">
                  <div class="person-title">
                    <span @click="editPersonName(index)" class="editable-name" :title="'点击修改' + person.name + '的姓名'">
                      {{ person.name }}
                    </span>
                    <button class="delete-btn" @click="deletePerson(index)" title="删除人员">
                      ×
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="month in months" :key="month">
                <td class="month-cell">{{ month }}月</td>
                <td v-for="person in platform.persons" :key="person.id" class="salary-cell">
                  <input
                    type="number"
                    class="salary-input"
                    v-model.number="person.salaries[month - 1]"
                    :placeholder="taxMode === 'personal' ? '请输入税前金额' : '请输入税后金额'"
                    min="0"
                    step="0.01"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 税务计算结果展示 -->
    <div v-if="Object.keys(calculationResults).length > 0" class="results-container">
      <h3 class="results-title">
        <p>个税计算结果</p>
        <p style="font-size: 12px;">（计算结果仅供参考，请以导入后个税预计算结果为准）</p>
      </h3>
      
      <div v-for="(result, personId) in calculationResults" :key="personId" class="person-result">
        <h4 class="person-result-title">{{ getPersonName(personId) }}</h4>
        
        <div class="result-table-wrapper">
          <table class="result-table">
            <thead>
              <tr>
                <th>月份</th>
                <th>当月薪资</th>
                <th>累计收入</th>
                <th>累计费用</th>
                <th>应纳税所得额</th>
                <th>税率(%)</th>
                <th>速算扣除</th>
                <th>本期税额</th>
                <th>累计税额</th>
                <th>实际税率(%)</th>
                <th>税后收入</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(month, index) in months" :key="month">
                <td class="month-cell">{{ month }}月</td>
                <td class="number-cell">{{ result.person_month_salaries[index] }}</td>
                <td class="number-cell">{{ result.person_total_salaries[index] }}</td>
                <td class="number-cell">{{ result.person_total_cumulative[index] }}</td>
                <td class="number-cell">{{ result.person_mounth_tax[index] }}</td>
                <td class="number-cell">{{ result.person_rate[index] }}</td>
                <td class="number-cell">{{ result.reduce_fee[index] }}</td>
                <td class="number-cell highlight-tax">{{ result.person_tax[index] }}</td>
                <td class="number-cell">{{ result.person_total_tax[index] }}</td>
                <td class="number-cell">{{ result.person_tax_rate[index] }}</td>
                <td class="number-cell highlight-income">{{ result.person_tax_income[index] }}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="summary-row">
                <td><strong>汇总</strong></td>
                <td class="number-cell"><strong>{{ getTotalMonthSalary(result) }}</strong></td>
                <td class="number-cell">-</td>
                <td class="number-cell">-</td>
                <td class="number-cell">-</td>
                <td class="number-cell">-</td>
                <td class="number-cell">-</td>
                <td class="number-cell highlight-tax"><strong>{{ getTotalTax(result) }}</strong></td>
                <td class="number-cell">-</td>
                <td class="number-cell"><strong>{{ getAverageTaxRate(result) }}%</strong></td>
                <td class="number-cell highlight-income"><strong>{{ getTotalAfterTax(result) }}</strong></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

    <div class="center-buttons">
      <button class="btn" @click="addPlatform">添加其他平台收入</button>
    </div>

    <!-- 底部按钮 -->
    <div class="footer-buttons">
      <button class="btn btn-reset" @click="resetData">重置数据</button>
      <button class="btn btn-primary" @click="submitCalculation">提交计算</button>
    </div>
  </div>
</template>

<script setup>

/* eslint-disable */
import { ref } from 'vue'

// 月份数组 1-12月
const months = Array.from({ length: 12 }, (_, i) => i + 1)

// 平台数据
const platforms = ref([
  {
    id: 1,
    name: '默认灵工平台',
    persons: [
      {
        id: 1,
        name: '默认人员（点击修改）',
        salaries: new Array(12).fill(null)
      }
    ]
  }
])

// 计算结果数据
const calculationResults = ref({})

// 计算模式：'personal' 个人承担，'company' 企业承担
const taxMode = ref('personal')

// 计数器
let personCounter = 1
let platformCounter = 1

// 添加平台
const addPlatform = () => {
  const platformName = prompt('请输入平台名称:', '')
  
  if (platformName === null) {
    return
  }
  
  if (!platformName.trim()) {
    alert('平台名称不能为空')
    return
  }
  
  // 检查平台名称是否重复
  const existingNames = platforms.value.map(p => p.name.trim().toLowerCase())
  if (existingNames.includes(platformName.trim().toLowerCase())) {
    alert('该平台名称已存在，请输入不同的名称')
    return
  }
  
  platformCounter++
  
  // 复制第一个平台的人员结构，但清空薪资数据
  const newPersons = platforms.value[0].persons.map(person => ({
    id: person.id,
    name: person.name,
    salaries: new Array(12).fill(null)
  }))
  
  platforms.value.push({
    id: platformCounter,
    name: platformName.trim(),
    persons: newPersons
  })
  
  alert(`已成功添加平台：${platformName.trim()}`)
}

// 删除平台
const deletePlatform = (platformIndex) => {
  if (platforms.value.length > 1) {
    const platformName = platforms.value[platformIndex].name
    if (confirm(`确定要删除平台“${platformName}”吗？`)) {
      platforms.value.splice(platformIndex, 1)
    }
  } else {
    alert('至少需要保留一个平台')
  }
}

// 添加人员（在所有平台中同步添加）
const addPerson = () => {
  // 获取用户输入的姓名
  const name = prompt('请输入人员姓名:', '')
  
  // 验证输入
  if (name === null) {
    return // 用户取消输入
  }
  
  if (!name.trim()) {
    alert('姓名不能为空')
    return
  }
  
  // 检查姓名是否重复（在第一个平台中检查）
  const existingNames = platforms.value[0].persons.map(p => p.name.trim().toLowerCase())
  if (existingNames.includes(name.trim().toLowerCase())) {
    alert('该姓名已存在，请输入不同的姓名')
    return
  }
  
  personCounter++
  
  // 在所有平台中添加同名人员
  platforms.value.forEach(platform => {
    platform.persons.push({
      id: personCounter,
      name: name.trim(),
      salaries: new Array(12).fill(null)
    })
  })
  
  alert(`已成功在所有平台添加人员：${name.trim()}`)
}

// 修改人员姓名（在所有平台中同步修改）
const editPersonName = (personIndex) => {
  const currentPerson = platforms.value[0].persons[personIndex]
  const newName = prompt('请输入新的姓名:', currentPerson.name)
  
  // 验证输入
  if (newName === null) {
    return // 用户取消输入
  }
  
  if (!newName.trim()) {
    alert('姓名不能为空')
    return
  }
  
  // 检查新姓名是否与其他人员重复
  const existingNames = platforms.value[0].persons
    .filter((_, index) => index !== personIndex) // 排除当前人员
    .map(p => p.name.trim().toLowerCase())
  
  if (existingNames.includes(newName.trim().toLowerCase())) {
    alert('该姓名已存在，请输入不同的姓名')
    return
  }
  
  const oldName = currentPerson.name
  
  // 在所有平台中同步修改姓名
  platforms.value.forEach(platform => {
    platform.persons[personIndex].name = newName.trim()
  })
  
  alert(`姓名已修改：${oldName} → ${newName.trim()}`)
}

// 删除人员（在所有平台中同步删除）
const deletePerson = (index) => {
  if (platforms.value[0].persons.length > 1) {
    const personName = platforms.value[0].persons[index].name
    if (confirm(`确定要删除人员“${personName}”吗？这将从所有平台中删除该人员。`)) {
      platforms.value.forEach(platform => {
        platform.persons.splice(index, 1)
      })
    }
  } else {
    alert('至少需要保留一个人员')
  }
}

// 一键录入（应用到所有平台）
const autoInput = () => {
  const amount = prompt('请输入要录入的金额:', '20000')
  
  // 验证输入
  if (amount === null) {
    return // 用户取消输入
  }
  
  const numAmount = parseFloat(amount)
  if (isNaN(numAmount) || numAmount < 0) {
    alert('请输入有效的金额数字')
    return
  }
  
  // 为所有平台的所有人员的所有月份录入该金额
  platforms.value.forEach(platform => {
    platform.persons.forEach(person => {
      person.salaries = person.salaries.map(() => numAmount)
    })
  })
}

// 重置数据
const resetData = () => {
  if (confirm('确定要重置所有平台的数据吗？')) {
    platforms.value.forEach(platform => {
      platform.persons.forEach(person => {
        person.salaries = new Array(12).fill(null)
      })
    })
    // 清空计算结果
    calculationResults.value = {}
  }
}

// 个税承担模式变化时的处理函数
const onTaxModeChange = () => {
  // 更新输入框提示文字
  const inputs = document.querySelectorAll('.salary-input')
  inputs.forEach(input => {
    input.placeholder = taxMode.value === 'personal' ? '请输入税前金额' : '请输入税后金额'
  })
}

// 获取人员名称
const getPersonName = (personId) => {
  const person = platforms.value[0].persons.find(p => p.id == personId)
  return person ? person.name : `人员${personId}`
}

// 获取人员在所有平台的累计数据
const getPersonCumulativeData = (personId) => {
  const cumulativeSalaries = new Array(12).fill(0)
  
  // 遍历所有平台，累计每个月份的数据
  platforms.value.forEach(platform => {
    const person = platform.persons.find(p => p.id === personId)
    if (person) {
      person.salaries.forEach((salary, monthIndex) => {
        if (salary && !isNaN(salary)) {
          cumulativeSalaries[monthIndex] += parseFloat(salary)
        }
      })
    }
  })
  
  return {
    id: personId,
    name: getPersonName(personId),
    salaries: cumulativeSalaries
  }
}

// 计算辅助函数
const getTotalMonthSalary = (result) => {
  return result.person_month_salaries.reduce((sum, val) => sum + val, 0).toFixed(2)
}

const getEndData = (result, field, fiexd) => {
  let resData = result[field][result[field].length - 1];
  fiexd && (resData = resData.toFixed(2));
  return resData
}

const getTotalIncome= (result) => {
  return result.taxable_income[result.taxable_income.length - 1].toFixed(2)
}

const getTotalTax = (result) => {
  return result.person_tax.reduce((sum, val) => sum + val, 0).toFixed(2)
}

const getTotalAfterTax = (result) => {
  return result.person_tax_income.reduce((sum, val) => sum + val, 0).toFixed(2)
}

const getAverageTaxRate = (result) => {
  const totalSalary = result.person_month_salaries.reduce((sum, val) => sum + val, 0)
  const totalTax = result.person_tax.reduce((sum, val) => sum + val, 0)
  return totalSalary > 0 ? ((totalTax / totalSalary) * 100).toFixed(2) : '0.00'
}

// 提交计算（基于累计数据）
const submitCalculation = () => {
  // 清空之前的结果
  calculationResults.value = {}
  
  // 收集所有输入的数据
  console.log('=== 税务计算结果（多平台累计） ===');
  
  // 获取所有人员ID（从第一个平台获取）
  const personIds = platforms.value[0].persons.map(p => p.id)
  
  personIds.forEach((personId) => {
    // 获取该人员在所有平台的累计数据
    const cumulativePersonData = getPersonCumulativeData(personId)
    const person_tax_info = getPersonTaxInfo(cumulativePersonData);
    
    // 存储计算结果用于页面显示
    calculationResults.value[personId] = person_tax_info;
    
    console.log(`\n【${cumulativePersonData.name}】税务计算详情（累计所有平台）:`);
    console.log('月份\t\t当月薪资\t累计收入\t累计费用\t应纳税所得额\t税率(%)\t速算扣除\t本期税额\t累计税额\t实际税率(%)\t税后收入');
    
    for (let i = 0; i < 12; i++) {
      const monthData = {
        month: i + 1,
        salary: person_tax_info.person_month_salaries[i],
        cumulative_income: person_tax_info.person_total_salaries[i],
        cumulative_cost: person_tax_info.person_total_cumulative[i],
        taxable_income: person_tax_info.person_mounth_tax[i],
        tax_rate: person_tax_info.person_rate[i],
        fast_deduct: person_tax_info.reduce_fee[i],
        current_tax: person_tax_info.person_tax[i],
        cumulative_tax: person_tax_info.person_total_tax[i],
        real_tax_rate: person_tax_info.person_tax_rate[i],
        after_tax_income: person_tax_info.person_tax_income[i]
      };
      
      console.log(`${monthData.month}月\t\t${monthData.salary}\t\t${monthData.cumulative_income}\t\t${monthData.cumulative_cost}\t\t${monthData.taxable_income}\t\t${monthData.tax_rate}\t\t${monthData.fast_deduct}\t\t${monthData.current_tax}\t\t${monthData.cumulative_tax}\t\t${monthData.real_tax_rate}\t\t${monthData.after_tax_income}`);
    }
  });
  
  console.log('\n=== 计算完成 ===');
}

// 扣税阶梯
const get_calc_tax_info = (number) => {
  const tax_list = [
    { min: 0, max: 36000, tax: 0.03, fast_deduct: 0 },
    { min: 36000, max: 144000, tax: 0.10, fast_deduct: 2520 },
    { min: 144000, max: 300000,tax: 0.20, fast_deduct: 16920 },
    { min: 300000, max: 420000, tax: 0.25, fast_deduct: 31920 },
    { min: 420000, max: 660000, tax: 0.30, fast_deduct: 52920 },
    { min: 660000, max: 960000, tax: 0.35, fast_deduct: 82920 },
    { min: 960000, max: "infinity", tax: 0.45, fast_deduct: 181920 }
  ];
  let tax_item = { tax: 0, fast_deduct: 0 }; // 默认税率
  for (let index = 0; index < tax_list.length; index++) {
    // 处理 infinity 的情况
    if (tax_list[index].max === "infinity") {
      if (tax_list[index].min <= number) {
        tax_item = tax_list[index];
        break;
      }
    } else {
      if (tax_list[index].min <= number && number <= tax_list[index].max) {
        tax_item = tax_list[index];
        break;
      }
    }
  }
  return {
    tax: (tax_item && tax_item.tax) || 0,
    fast_deduct: (tax_item && tax_item.fast_deduct) || 0,
    tax_item: tax_item || { tax: 0, fast_deduct: 0 }
  }
};

// 获取当前人员 12 个月的税收信息
const getPersonTaxInfo = (person) => {
  // 如果是企业承担个税模式，使用反向计算
  if (taxMode.value === 'company') {
    return getPersonTaxInfoCompany(person);
  }
  
  // 个人承担个税模式（原有逻辑）
  // 需要计算的所有月份
  const month_array = months;
  // 当前已存在月份的人员薪资
  const person_salaries_array = person.salaries;
  
  // 结果数组
  const results = {
    person_month_salaries: [],      // 当月薪资
    person_total_salaries: [],      // 累计收入
    person_total_cumulative: [],    // 累计费用
    person_mounth_tax: [],          // 应纳税所得额
    person_rate: [],                // 个税预扣费率
    reduce_fee: [],                 // 速算扣除数
    person_tax: [],                 // 本期应缴税额
    person_total_tax: [],           // 累计已缴税额
    person_tax_rate: [],            // 实际税率
    person_tax_income: [],          // 税后收入
    person_tax_add: []              // 增值税和附加
  };
  
  // 累计变量（重置条件：当月无收入时下月重新开始）
  let cumulative_income = 0;        // 累计收入
  let cumulative_cost = 0;          // 累计费用（收入的20%）
  let cumulative_months = 0;        // 累计月份数（用于计算减除费用）
  let cumulative_paid_tax = 0;      // 累计已缴税额
  
  const getNumber = (num) => {
    if (isNaN(num) || !isFinite(num)) {
      return 0;
    }
    return Math.round(num * 100) / 100;
  };
  
  for (let i = 0; i < month_array.length; i++) {
    // 当前月份薪资
    let current_month_salary = person_salaries_array[i] || 0;
    
    // 如果当月无收入，重置累计变量，所有计算结果为0
    if (!current_month_salary || current_month_salary <= 0) {
      // 重置累计变量
      cumulative_income = 0;
      cumulative_cost = 0;
      cumulative_months = 0;
      cumulative_paid_tax = 0;
      
      // 当月所有结果为0
      results.person_month_salaries.push(0);
      results.person_total_salaries.push(0);
      results.person_total_cumulative.push(0);
      results.person_mounth_tax.push(0);
      results.person_rate.push(0);
      results.reduce_fee.push(0);
      results.person_tax.push(0);
      results.person_total_tax.push(0);
      results.person_tax_rate.push(0);
      results.person_tax_income.push(0);
      results.person_tax_add.push(0);
      continue;
    }
    
    // 有收入的月份，进行累计计算
    cumulative_months += 1;
    cumulative_income += current_month_salary;
    cumulative_cost += current_month_salary * 0.2; // 费用按收入的20%计算
    
    // 累计减除费用：5000元/月 × 累计月份数
    let cumulative_deduction = cumulative_months * 5000;
    
    // 累计应纳税所得额 = 累计收入 - 累计费用 - 累计减除费用
    let cumulative_taxable_income = cumulative_income - cumulative_cost - cumulative_deduction;
    
    // 确保应纳税所得额不为负数
    cumulative_taxable_income = Math.max(0, cumulative_taxable_income);
    
    // 根据累计应纳税所得额确定税率和速算扣除数
    let tax_info = get_calc_tax_info(cumulative_taxable_income);
    let tax_rate = (tax_info && tax_info.tax) || 0;
    let fast_deduct = (tax_info && tax_info.fast_deduct) || 0;
    
    // 累计应预扣预缴税额 = 累计应纳税所得额 × 预扣率 - 速算扣除数
    let cumulative_should_pay_tax = cumulative_taxable_income * tax_rate - fast_deduct;
    cumulative_should_pay_tax = Math.max(0, cumulative_should_pay_tax);
    
    // 本期应预扣预缴税额 = 累计应预扣预缴税额 - 累计已预扣预缴税额
    let current_month_tax = cumulative_should_pay_tax - cumulative_paid_tax;
    current_month_tax = Math.max(0, current_month_tax);
    
    // 更新累计已缴税额
    cumulative_paid_tax += current_month_tax;
    
    // 计算实际税率（本期税额/当月收入）
    let real_tax_rate = current_month_salary > 0 ? (current_month_tax / current_month_salary) * 100 : 0;
    
    // 税后收入
    let after_tax_income = current_month_salary - current_month_tax;
    
    // 增值税及附加（根据实际业务需求计算，这里暂设为0）
    let vat_and_additional = 0;
    
    // 存储结果
    results.person_month_salaries.push(getNumber(current_month_salary));
    results.person_total_salaries.push(getNumber(cumulative_income));
    results.person_total_cumulative.push(getNumber(cumulative_cost));
    results.person_mounth_tax.push(getNumber(cumulative_taxable_income));
    results.person_rate.push(getNumber(tax_rate * 100)); // 转换为百分比
    results.reduce_fee.push(getNumber(fast_deduct));
    results.person_tax.push(getNumber(current_month_tax));
    results.person_total_tax.push(getNumber(cumulative_paid_tax));
    results.person_tax_rate.push(getNumber(real_tax_rate));
    results.person_tax_income.push(getNumber(after_tax_income));
    results.person_tax_add.push(getNumber(vat_and_additional));
  }
  
  return results;
}

// 获取当前人员 12 个月的税收信息（企业承担个税模式）
const getPersonTaxInfoCompany = (person) => {
  // 需要计算的所有月份
  const month_array = months;
  // 当前已存在月份的人员薪资（这里是税后收入）
  const person_after_tax_array = person.salaries;
  
  // 结果数组
  const results = {
    person_month_salaries: [],      // 当月薪资（含税金额）
    person_total_salaries: [],      // 累计收入
    person_total_cumulative: [],    // 累计费用
    person_mounth_tax: [],          // 应纳税所得额
    person_rate: [],                // 个税预扣费率
    reduce_fee: [],                 // 速算扣除数
    person_tax: [],                 // 本期应缴税额
    person_total_tax: [],           // 累计已缴税额
    person_tax_rate: [],            // 实际税率
    person_tax_income: [],          // 税后收入（用户输入的金额）
    person_tax_add: []              // 增值税和附加
  };
  
  // 累计变量（重置条件：当月无收入时下月重新开始）
  let cumulative_income = 0;        // 累计收入（含税）
  let cumulative_cost = 0;          // 累计费用（收入的20%）
  let cumulative_months = 0;        // 累计月份数（用于计算减除费用）
  let cumulative_paid_tax = 0;      // 累计已缴税额
  
  const getNumber = (num) => {
    if (isNaN(num) || !isFinite(num)) {
      return 0;
    }
    return Math.round(num * 100) / 100;
  };
  
  for (let i = 0; i < month_array.length; i++) {
    // 当前月份税后收入
    let current_month_after_tax = person_after_tax_array[i] || 0;
    
    // 如果当月无收入，重置累计变量，所有计算结果为0
    if (!current_month_after_tax || current_month_after_tax <= 0) {
      // 重置累计变量
      cumulative_income = 0;
      cumulative_cost = 0;
      cumulative_months = 0;
      cumulative_paid_tax = 0;
      
      // 当月所有结果为0
      results.person_month_salaries.push(0);
      results.person_total_salaries.push(0);
      results.person_total_cumulative.push(0);
      results.person_mounth_tax.push(0);
      results.person_rate.push(0);
      results.reduce_fee.push(0);
      results.person_tax.push(0);
      results.person_total_tax.push(0);
      results.person_tax_rate.push(0);
      results.person_tax_income.push(0);
      results.person_tax_add.push(0);
      continue;
    }
    
    // 有收入的月份，需要反向计算含税金额
    // 使用更精确的二分法计算含税金额
    let left = current_month_after_tax;
    let right = current_month_after_tax * 1.5; // 含税金额不会超过税后金额的1.5倍
    let current_month_salary = (left + right) / 2;
    let current_month_tax = 0;
    let iterations = 0;
    const maxIterations = 100;
    
    // 二分法计算含税金额
    while (iterations < maxIterations) {
      // 计算当前含税金额下的税额
      // 临时累计变量用于计算
      let temp_cumulative_income = cumulative_income + current_month_salary;
      let temp_cumulative_cost = cumulative_cost + current_month_salary * 0.2; // 费用按收入的20%计算
      let temp_cumulative_months = cumulative_months + 1;
      
      // 累计减除费用：5000元/月 × 累计月份数
      let temp_cumulative_deduction = temp_cumulative_months * 5000;
      
      // 累计应纳税所得额 = 累计收入 - 累计费用 - 累计减除费用
      let temp_cumulative_taxable_income = temp_cumulative_income - temp_cumulative_cost - temp_cumulative_deduction;
      temp_cumulative_taxable_income = Math.max(0, temp_cumulative_taxable_income);
      
      // 根据累计应纳税所得额确定税率和速算扣除数
      let tax_info = get_calc_tax_info(temp_cumulative_taxable_income);
      let tax_rate = (tax_info && tax_info.tax) || 0;
      let fast_deduct = (tax_info && tax_info.fast_deduct) || 0;
      
      // 累计应预扣预缴税额 = 累计应纳税所得额 × 预扣率 - 速算扣除数
      let temp_cumulative_should_pay_tax = temp_cumulative_taxable_income * tax_rate - fast_deduct;
      temp_cumulative_should_pay_tax = Math.max(0, temp_cumulative_should_pay_tax);
      
      // 本期应预扣预缴税额 = 累计应预扣预缴税额 - 累计已预扣预缴税额
      current_month_tax = temp_cumulative_should_pay_tax - (cumulative_paid_tax || 0);
      current_month_tax = Math.max(0, current_month_tax);
      
      // 计算税后收入
      let calculated_after_tax = current_month_salary - current_month_tax;
      
      // 检查计算结果是否接近目标值
      let difference = calculated_after_tax - current_month_after_tax;
      
      if (Math.abs(difference) < 0.01) {
        // 收敛，找到合适的含税金额
        break;
      }
      
      // 二分法调整含税金额
      if (calculated_after_tax > current_month_after_tax) {
        right = current_month_salary;
      } else {
        left = current_month_salary;
      }
      current_month_salary = (left + right) / 2;
      
      // 防止异常值
      if (!isFinite(current_month_salary) || current_month_salary <= 0) {
        current_month_salary = current_month_after_tax * 1.02; // 重置为合理初始值
        break;
      }
      
      iterations++;
      
      // 防止无限循环
      if (iterations >= maxIterations) {
        // 如果无法收敛，使用近似值
        current_month_salary = current_month_after_tax * 1.02;
        break;
      }
    }
    
    // 更新累计变量
    cumulative_months += 1;
    cumulative_income += current_month_salary;
    cumulative_cost += current_month_salary * 0.2; // 费用按收入的20%计算
    
    // 累计减除费用：5000元/月 × 累计月份数
    let cumulative_deduction = cumulative_months * 5000;
    
    // 累计应纳税所得额 = 累计收入 - 累计费用 - 累计减除费用
    let cumulative_taxable_income = cumulative_income - cumulative_cost - cumulative_deduction;
    cumulative_taxable_income = Math.max(0, cumulative_taxable_income);
    
    // 根据累计应纳税所得额确定税率和速算扣除数
    let tax_info = get_calc_tax_info(cumulative_taxable_income);
    let tax_rate = (tax_info && tax_info.tax) || 0;
    let fast_deduct = (tax_info && tax_info.fast_deduct) || 0;
    
    // 累计应预扣预缴税额 = 累计应纳税所得额 × 预扣率 - 速算扣除数
    let cumulative_should_pay_tax = cumulative_taxable_income * tax_rate - fast_deduct;
    cumulative_should_pay_tax = Math.max(0, cumulative_should_pay_tax);
    
    // 本期应预扣预缴税额 = 累计应预扣预缴税额 - 累计已预扣预缴税额
    current_month_tax = cumulative_should_pay_tax - cumulative_paid_tax;
    current_month_tax = Math.max(0, current_month_tax);
    
    // 更新累计已缴税额
    cumulative_paid_tax += current_month_tax;
    
    // 计算实际税率（本期税额/当月含税收入）
    let real_tax_rate = current_month_salary > 0 ? (current_month_tax / current_month_salary) * 100 : 0;
    
    // 税后收入（用户输入的金额）
    let after_tax_income = current_month_after_tax;
    
    // 增值税及附加（根据实际业务需求计算，这里暂设为0）
    let vat_and_additional = 0;
    
    // 存储结果
    results.person_month_salaries.push(getNumber(current_month_salary));
    results.person_total_salaries.push(getNumber(cumulative_income));
    results.person_total_cumulative.push(getNumber(cumulative_cost));
    results.person_mounth_tax.push(getNumber(cumulative_taxable_income));
    results.person_rate.push(getNumber(tax_rate * 100)); // 转换为百分比
    results.reduce_fee.push(getNumber(fast_deduct));
    results.person_tax.push(getNumber(current_month_tax));
    results.person_total_tax.push(getNumber(cumulative_paid_tax));
    results.person_tax_rate.push(getNumber(real_tax_rate));
    results.person_tax_income.push(getNumber(after_tax_income));
    results.person_tax_add.push(getNumber(vat_and_additional));
  }
  
  return results;
}

/* eslint-enable */
</script>